import React, { useState } from "react";
import "./ProblemEditLayout.css";
import { renderStatementWithKaTeX } from "../../../../../Status";
import { DeletingProblemByReferenceCode, EditingProblemByReferenceCode } from "../../../../../Functions/CRUD/Problem/problemHelper";

const ProblemEditLayout = ({ problem,setLoading }) => {
  const [EditOn, setEditOn] = useState(false);
  const [ProblemStatement, setProblemStatement] = useState(problem?.statement);
  return (
    <div className="probleEdit-container">
      <h2 className="pod-heading" style={{ color: "#156874" }}>
        {problem?.type === "Daily"
          ? "🔍 Problem of the Day"
          : problem?.type === "Unit"
          ? `🔍 Unit Problem : # ${problem?.referenceCode}`
          : "🔍 Problem of the Weel"}
      </h2>

      <div className="pod-content">
        <div className="pod-tags">
          <span
            className={`pod-difficulty ${problem?.difficulty.toLowerCase()}`}
          >
            {problem?.difficulty}
          </span>
          {problem?.tags.map((tag, index) => (
            <span className="pod-tag" key={index}>
              {tag}
            </span>
          ))}
        </div>
        {!EditOn ? (
          <h3 className="pod-title">
            {renderStatementWithKaTeX(problem?.statement)}
          </h3>
        ) : (
          <textarea
            value={ProblemStatement}
            onChange={(e) => setProblemStatement(e.target.value)}
          />
        )}
        <p className="pod-meta">
          Posted on {problem?.postedAt} by {problem?.author}
        </p>

        <div className="pod-buttons-conatiner">
          {!EditOn ? (
            <button className="pod-button-SC" onClick={() => setEditOn(true)}>
              Edit Problem
            </button>
          ) : (
            <button
              className="pod-button-SC"
              onClick={async () => {
                
                setLoading(true)
                await EditingProblemByReferenceCode(problem?.referenceCode,{statement:ProblemStatement})
               
                setLoading(false)
                setEditOn(false);
                window.location.reload()
              }}
            >
              Save Edit
            </button>
          )}
          <button className="delete-button" onClick={async () => {
                
                setLoading(true)
                await DeletingProblemByReferenceCode(problem?.referenceCode)
               
                setLoading(false)
                setEditOn(false);
                window.location.reload()
              }}>Delete Problem</button>
        </div>
      </div>
    </div>
  );
};

export default ProblemEditLayout;
